import React from 'react';
import { Box, Text, Flex, Image, Link, useMediaQuery } from '@chakra-ui/react';
import Etherscan from '../assets/social-media-icons/etherscan.png';
import Opensea from '../assets/social-media-icons/os.png';
import Twitter from '../assets/social-media-icons/twitter.png';
import ButtonPress from './ButtonPress';

const NavBar = ({ accounts, setAccounts}) => {
    const isConnected = Boolean(accounts[0]);
    const [isLargerThan800] = useMediaQuery('(min-width: 800px)');

    async function connectAccount() {
        if (window.ethereum) {
            const accounts = await window.ethereum.request({
                method: 'eth_requestAccounts',
            });
            setAccounts(accounts);
        }
    }

    return (
        <Flex
            justify='space-between'
            align='center'
            paddingBottom='10px'
            flexDirection={ isLargerThan800 ? 'row' : 'column' }
        >
            {/* Left Side - Social Media Icons */}
            <Flex justify='space-around' width={ isLargerThan800 ? '35%' : '100%' } padding={ isLargerThan800 ? '0 10px' : '0 60px'}>
                <Link href='https://etherscan.io/address/0x75239771a2a5d01677a5d3154f7ed60152fa5572' target='_blank'>
                    <Image src={Etherscan} boxSize='80px' margin='0 10px' />
                </Link>
                <Link href='https://opensea.io/collection/the-civilianz' target='_blank'>
                    <Image src={Opensea} boxSize='80px' margin='0 10px' />
                </Link>
                <Link href='https://twitter.com/TheCivilianzNFT' target='_blank'>
                    <Image src={Twitter} boxSize='80px' margin='0 10px' />
                </Link>
            </Flex>

            <Flex justify='space-around' align='center' width={ isLargerThan800 ? '35%' : '100%' } padding='20px'>
                <Text
                    fontSize='32px'
                    lineHeight='38px'
                    >
                        The Civilianz
                </Text>
            </Flex>

            {/* Right Side - Connect*/}
            <Flex
                id='connect-wrapper'
                justify='space-around'
                align='center'
                width={ isLargerThan800 ? '35%' : '100%' }
            >

            {/* Connect */}
            {isConnected ? (
                <Box 
                    margin='0 15px'
                    fontSize='24px'
                    textShadow='2px 2px 2px black'
                    >
                        Connected</Box>
            ) : (
                <ButtonPress
                    backgroundColor='#6a6e74'
                    borderRadius='5px'
                    boxShadow='2px 2px 2px 1px #0F0F0F'
                    textShadow='2px 2px 2px black'
                    color='white'
                    cursor='pointer'
                    fontFamily='inherit'
                    fontSize='24px'
                    padding='15px'
                    margin='0 15px'
                    onClick={connectAccount}
                >
                    Connect
                </ButtonPress>
            )}

            </Flex>


        </Flex>
    );
};

export default NavBar;